import { clamp01, easeOutBack, easeOutCubic, lerp } from "./easing.js";

export const TILE_ENTRANCE_MS = 420;
export const tileEntranceDelay = (index, size) =>
  (Math.floor(index / size) + index % size) * 34;

/** A diagonal wave settles each tile from slightly larger and above its home. */
export function boardEntrancePose(elapsed, index, size, reduced = false) {
  const progress = reduced ? 1 : clamp01((elapsed - tileEntranceDelay(index, size)) / TILE_ENTRANCE_MS);
  return {
    scale: lerp(1.28, 1, easeOutBack(progress, 0.8)),
    y: lerp(-14, 0, easeOutCubic(progress)),
    alpha: easeOutCubic(clamp01(progress / 0.3)),
    done: progress === 1,
  };
}
